import SearchSubCategory from "#app/pages/IncomeAndExpenses/components/BaseOperationList/form/SearchSubCategory";
import {EditText, Plus} from "#app/pages/IncomeAndExpenses/components/BaseOperationList/style";
import React, {useState} from "react";

export const SubCategoryDisplay = ({ item, subcategoryType, subcategories }) => {
    const [editSubcategory, setEditSubcategory] = useState(false);

    return item.editable && editSubcategory ? (
        <SearchSubCategory
            item={item}
            subcategoryType={subcategoryType}
            subcategories={subcategories}
            finishEdit={() => setEditSubcategory(false)}
        />
    ) : (
        item.subcategory_text ? (
            <EditText id={`edit-subcategory-${item.id}`} onClick={() => setEditSubcategory(true)}>
                {item.subcategory_text}
            </EditText>
        ) : (
            <Plus id={`edit-subcategory-${item.id}`} onClick={() => setEditSubcategory(true)}/>
        )
    )
};